import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { IProjects } from '../Interfaces/IProjects';
import { INDAManagement } from '../Interfaces/INDAManagement';

@Injectable({
	providedIn: 'root',
})
export class ProjectsService extends RestCallService {
  public dataToSend: IProjects = {
    pkproject: 0,
    pkprojectnda: 0,
    fksite: 0,
    fkndamanagement: 0,
    sitename: '',
    project: '',
    requirednda: false,
    available: false,
    configured: false,
    creationdate: new Date,
    strcreationdate: '',
    fkemployeecreator: 0,
    lastupdated: new Date,
    strlastupdated: '',
    fkemployeeupdater: 0,
    employeecreatorname: '',
    employeeupdatername: '',
    username: '',
    buildings_array: [],
    fk_building: 0,
  };

  constructor(
    public httpClient: HttpClient,
    private cognitoService: CognitoService,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService,
  ) {     
          super(httpClient, 'JACSapi', toastr, notificationService, translate);
    }
      
  public GetAvailableProjects() {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IProjects[]>('/api/Projects/GetAvailableProjects', this.dataToSend);
  }

  public GetList() {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IProjects[]>('/api/Projects/GetProjects', this.dataToSend);
  }

  public GetProjectsWithBuildings() {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IProjects[]>('/api/Projects/GetProjectsAndBuildings', this.dataToSend);
  }

  public GetProjectsByBuilding(data:any) {
    if (!this.cognitoService.IsAuhtenticated()) {
      this.cognitoService.LogOut();
    }
    this.dataToSend.fk_building = data;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IProjects[]>('/api/Projects/GetProjectsByBuilding', this.dataToSend);
  }

  public CreateProject(data: any) { 
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.project = data.txtproject.trim();
    this.dataToSend.requirednda = data.requirednda;
    this.dataToSend.buildings_array = data.cbbuildings;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    
    return this.post<IProjects[]>('/api/Projects/CreateProject', this.dataToSend);
  }
    
  public UpdateProject(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.pkproject = data.pkproject;
    this.dataToSend.project = data.txtproject.trim();
    this.dataToSend.requirednda = data.requirednda;
    this.dataToSend.buildings_array = data.cbbuildings;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    
    return this.put('/api/Projects/UpdateProject', this.dataToSend);
  }

  public ChangeStatusProject(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.pkproject = data.pkproject;
    this.dataToSend.available = data.available;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Projects/ChangeStatusProject', this.dataToSend);
  }
  
  
  public GetNDAByProject(data: any) {
      if (!this.cognitoService.IsAuhtenticated())
          this.cognitoService.LogOut();
      this.dataToSend.pkproject = data.pkproject;
      this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
      return this.post<INDAManagement[]>('/api/NDAManagements/GetNDAByProject', this.dataToSend);
  }

  public AddNDA(data: any){
      if (!this.cognitoService.IsAuhtenticated())
          this.cognitoService.LogOut();
      this.dataToSend.pkproject = data.pkproject;
      this.dataToSend.fkndamanagement = data.fkndamanagement;
      this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
      return this.post('/api/Projects/AddNDA', this.dataToSend);
  }

  public DisableProjectNDA(data: any) {
      if (!this.cognitoService.IsAuhtenticated())
          this.cognitoService.LogOut();
      this.dataToSend.pkproject = data.pkproject;
      this.dataToSend.pkprojectnda = data.pkprojectnda;
      this.dataToSend.fkndamanagement = data.fkndamanagement;
      this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
      return this.post('/api/Projects/DisableProjectNDA', this.dataToSend);
  }

  public CreateProjectBuilding(data: any)
  {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkproject = data.pkproject;
    this.dataToSend.buildings_array = data.cbbuildings;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post('/api/Projects/SetProjectByBuildings', this.dataToSend);
  }

  public UpdateProjectBuilding(data: any)
  {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkproject = data.pkproject;
    this.dataToSend.buildings_array = data.cbbuildings;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post('/api/Projects/UpdateProjectByBuildings', this.dataToSend);
  }
}
